export interface AdminMenuItem {
  id: string;
  label: string;
  icon: string;
  path: string;
  children?: AdminMenuItem[];
}

export const ADMIN_MENU: AdminMenuItem[] = [
  {
    id: 'content',
    label: '콘텐츠 관리',
    icon: 'ri-dashboard-line',
    path: '/admin',
    children: [
      { id: 'notice', label: '상단 공지', icon: 'ri-megaphone-line', path: '/admin/notice' },
      { id: 'company', label: '회사정보', icon: 'ri-building-2-line', path: '/admin/company' },
      { id: 'hero', label: '홈 히어로 배경', icon: 'ri-image-line', path: '/admin/hero' },
      { id: 'cta', label: 'CTA 섹션 배경', icon: 'ri-image-2-line', path: '/admin/cta' },
      { id: 'finishing', label: '제품 후가공 썸네일', icon: 'ri-layout-grid-line', path: '/admin/finishing' },
      { id: 'category', label: '카테고리 이미지', icon: 'ri-stack-line', path: '/admin/category' },
    ],
  },
  { id: 'customers', label: '고객 관리', icon: 'ri-user-search-line', path: '/admin/customers' },
  { id: 'quotation', label: 'Quotation Template', icon: 'ri-file-list-3-line', path: '/admin/quotation-template' },
];

export const ADMIN_PAGE_TITLES: Record<string, string> = {
  '/admin': '사이트 콘텐츠 관리',
  '/admin/notice': '상단 공지',
  '/admin/company': '회사정보',
  '/admin/hero': '홈 히어로 배경',
  '/admin/cta': 'CTA 섹션 배경',
  '/admin/finishing': '제품 후가공 썸네일',
  '/admin/category': '카테고리 이미지',
  '/admin/customers': '고객 관리',
  '/admin/quotation-template': 'Quotation Template Studio',
};

export function getAdminPageTitle(pathname: string): string {
  if (pathname.startsWith('/admin/customers/')) return '고객 상세';
  return ADMIN_PAGE_TITLES[pathname] || '관리자 콘솔';
}